import { t } from '@/shared/lib/i18n'
import { cn } from '@/shared/lib/utils'

type Props = {
  show: boolean
  className?: string
}

export function ReportRangeOrderError({ show, className }: Props) {
  if (!show) return null
  return (
    <p
      role="alert"
      className={cn(
        'text-sm text-destructive',
        className ?? 'w-full basis-full min-w-0 sm:col-span-2',
      )}
    >
      {t('reports.validation.endBeforeStart')}
    </p>
  )
}
